import { useContext, useEffect, useState } from 'react'
// import { ToDoListAdminProvider } from './ToDoListAdminProvider'
import { BiCollapse, BiExpand } from 'react-icons/bi'
import { BsClipboard2Check } from 'react-icons/bs'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'
import { ToDoListAdminContext } from '../ToDoListAdmin'
import AddItemComponent from './AddItemComponent'
import ToDoListItemsLineItem from './ToDoListItemsLineItem'
import ToDoListItemsStatusLineItem from './ToDoListItemsStatusLineItem'
import ToDoListLineItem from './ToDoListLineItem'
import ToggleContainerComponent from './ToggleContainerComponent'

export default function ToDoListOverview() {
    const { loadToDoLists,
        ToDoLists,
        addToDoLists,
        removeToDoList,
        renameToDoList,
        addToDoListItem,
        removeToDoListItem,
        renameToDoListItem,
        addToDoListItemStatus
    } = useContext(ToDoListAdminContext)

    const { GlobalRef } = useContext(CommonFunctionsContext)

    const [collapsed, setCollapsed] = useState(false)
    useEffect(() => { loadToDoLists() }, [])

    return (
        <>
            <div className='to-do-lists-container' style={{ overflow: 'auto', maxHeight: 'calc(100% - 125px)' }}>
                <div
                    ref={r => GlobalRef(r, 'FacilityToDoListNewListName')}
                    className={'text-end w-100'}>
                    <button className='btn' onClick={() => setCollapsed(!collapsed)}>{!collapsed ? <BiExpand /> : <BiCollapse />} </button>
                </div>
                <AddItemComponent
                    focused={{
                        group: undefined,
                        item: undefined,
                        status: undefined,
                        properties: undefined
                    }}
                    className={'bg-primary-container p-2 rounded'} description={'to do list'} align={'center'} onAdd={addToDoLists} />
                <div ref={r => GlobalRef(r, 'FacilityToDoListItems')}>
                    {ToDoLists && ToDoLists.map((group) =>

                        <ToDoListLineItem
                            key={`ToDo-${group.resource.resource.id}`}
                            group={group.resource}
                            collapsed={collapsed}
                            onRemove={async () => await removeToDoList(group.resource.resource)}
                            onEdit={async (name) => await renameToDoList(group.resource.resource, name)}
                        >
                            <div key={group.resource.id} className='group-container p-1 '>
                                <div className='ps-3 '>
                                    <div className='d-flex justify-content-center align-items-center'><b><BsClipboard2Check />List Items</b></div></div>
                                {group.resources && group.resources.map((list) =>
                                    <ToDoListItemsLineItem list={list.resource} group={group.resource.resource}
                                        onRemove={async () => await removeToDoListItem(group.resource.resource, list.resource)}
                                        onEdit={async (name) => await renameToDoListItem(group.resource.resource, list.resource, name)}>
                                        <div
                                            className='statuses-container bg-primary-container rounded p-1 shadow mb-2 small'>
                                            <ToggleContainerComponent
                                                open={collapsed}
                                                focused={{
                                                    group: group.resource.resource.id,
                                                    item: list.resource.id,
                                                    status: undefined,
                                                    properties: undefined
                                                }}
                                                id={list.resource.id}
                                                header={'Statuses'}>
                                                {list.resources && list.resources.map((item) =>
                                                    <ToDoListItemsStatusLineItem group={group.resource.resource} list={list.resource.resource} item={item.resource} />
                                                )}
                                                <AddItemComponent
                                                    focused={{
                                                        group: group.resource.resource.id,
                                                        item: list.resource.id,
                                                        status: undefined,
                                                        properties: undefined
                                                    }}
                                                    description={'status'} onAdd={async (st) => await addToDoListItemStatus(group.resource.resource, list.resource.resource, st)} />
                                            </ToggleContainerComponent>
                                        </div>
                                    </ToDoListItemsLineItem>)}
                                <AddItemComponent
                                    open={!group.resources || group.resources.length === 0}
                                    // open={true}
                                    focused={{
                                        group: group.resource.resource && group.resource.resource.id,
                                        item: undefined,
                                        status: undefined,
                                        properties: undefined
                                    }}
                                    description={'list item'} onAdd={async (name) => await addToDoListItem(group.resource.resource, name)} />
                            </div>
                        </ToDoListLineItem>
                    )}
                </div>
            </div>
        </>)
}